import React, { useState } from "react";
import { Eye, EyeOff, Mail, Lock } from "lucide-react";
import VRSOrbitLogo from "../../../../Assets/vrs orbit logo.png";
import avatar from "../../../../Assets/avatar.png";
import desk from "../../../../Assets/rafiki.png";
import leftBg from "../../../../Assets/left-bg.png";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { OrbitAdminLogin } from "../../AdminServices/AdminLoginService";
import NotificationAlert from "../../../Alerts/NotificationAlert";

const AdminLogin = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [keepMeLoggedIn, setKeepMeLoggedIn] = useState(false);
  const [loading, setLoading] = useState(false);

  //  Alert state
  const [alert, setAlert] = useState({ show: false, type: "", message: "" });

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    if (!email.trim() || !password.trim()) {
      setAlert({
        show: true,
        type: "warning",
        message: "Please enter both email and password.",
      });
      return;
    }

    setLoading(true);

    try {
      const result = await OrbitAdminLogin(email, password, keepMeLoggedIn);

      if (result && result.status === "Success") {
        const token = result.token?.token;

        if (token) {
          Cookies.set("Orbit_Token", token, {
            secure: true,
            sameSite: "Strict",
          });
        }

        setAlert({
          show: true,
          type: "success",
          message: result.message || "Login successfully Redirecting...",
        });

        // Delay navigation slightly to show the alert
        setTimeout(() => navigate("/Admin-Home"), 1500);
      } else {
        setAlert({
          show: true,
          type: "error",
          message: result.message || "Invalid credentials. Please try again.",
        });
      }
    } catch (error) {
      if (error.response?.status === 400) {
        navigate("/bad-request", {
          state: {
            error: error.response?.data?.message || "Bad request (400)",
          },
        });
        return;
      }

      setAlert({
        show: true,
        type: "error",
        message: error.message || "Login failed. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row-reverse relative">
      <NotificationAlert
        show={alert.show}
        type={alert.type}
        message={alert.message}
        duration={2500}
        onClose={() => setAlert({ ...alert, show: false })}
      />

      {/* Left Side*/}
      <div
        className="hidden md:flex flex-col items-center justify-center w-1/2 text-white p-10 relative overflow-hidden"
        style={{
          backgroundImage: `url(${leftBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="relative z-10 text-center">
          <img
            src={avatar}
            alt="Avatar"
            className="mx-auto w-30 h-20 mb-[43px]"
          />
          <h1 className="text-3xl font-bold mb-2">WELCOME TO ADMIN LOGIN!</h1>
          <p className="text-lg mb-10">
            To keep connected with us <br /> please login with your personal
            info
          </p>
          <img
            src={desk}
            alt="Desk Illustration"
            className="mx-auto w-[450px] mt-6"
          />
        </div>
      </div>

      {/* Right Side */}
      <div className="flex flex-col justify-center items-center w-full md:w-1/2 bg-white px-4 py-8 sm:px-6 md:p-8">
        <div className="max-w-md w-full">
          <div className="flex items-center justify-center mb-10 sm:mb-16">
            <img
              src={VRSOrbitLogo}
              alt="VRS Orbit"
              className="mr-2 w-full max-w-[450px]"
            />
          </div>

          <h3 className="text-center text-base sm:text-lg font-semibold mb-8 sm:mb-10">
            Login in to your Admin account to continue
          </h3>

          <form className="space-y-4" onSubmit={handleLogin}>
            {/* Email */}
            <label>Email Address</label>
            <div className="relative">
              <Mail className="absolute left-3 top-3 text-gray-400" size={20} />
              <input
                type="email"
                placeholder="name@gmail.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full pl-10 pr-3 py-2 mb-6 sm:mb-8 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#007BFF]"
              />
            </div>

            {/* Password */}
            <label>Password</label>
            <div className="relative">
              <Lock className="absolute left-3 top-3 text-gray-400" size={20} />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full pl-10 pr-10 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#007BFF]"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-3 text-gray-500"
              >
                {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
              </button>
            </div>

            {/* Keep Me Logged In */}
            <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mt-2">
              <label className="flex items-center space-x-2 text-sm text-gray-700">
                <input
                  type="checkbox"
                  checked={keepMeLoggedIn}
                  onChange={() => setKeepMeLoggedIn(!keepMeLoggedIn)}
                  className="accent-[#0061A4] cursor-pointer"
                />
                <span>Keep me logged in</span>
              </label>

              <button
                type="button"
                className="text-[#0061A4] text-sm hover:underline font-medium self-start sm:self-auto"
              >
                Forgot your password?
              </button>
            </div>

            {/* Login Button */}
            <div className="flex justify-center mt-4">
              <button
                type="submit"
                disabled={loading}
                className={`w-full max-w-[220px] ${
                  loading
                    ? "bg-gray-400 cursor-not-allowed"
                    : "bg-gradient-to-r from-[#0061A4] to-[#00ACED]"
                } text-white py-2 rounded-md font-medium hover:opacity-90 transition`}
              >
                {loading ? "Loading..." : "Login"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;
